var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card-item min-height-100" }, [
    !_vm.isSummaryVisible
      ? _c("section", [
          _c("div", { staticClass: "mb-4" }, [
            _c("p", { staticClass: "is-size-6" }, [
              _vm._v(_vm._s(_vm.$t("treasury.selectFileType")) + ":"),
            ]),
          ]),
          _c("div", { staticClass: "columns" }, [
            _c(
              "div",
              { staticClass: "column" },
              [
                _c(
                  "b-dropdown",
                  {
                    attrs: {
                      "mobile-modal": false,
                      expanded: "",
                      "append-to-body": "",
                      "aria-role": "list",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "trigger",
                          fn: function ({ active }) {
                            return _c(
                              "b-button",
                              {
                                staticClass: "button",
                                attrs: { id: "dropdown-button", expanded: "" },
                              },
                              [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.selectedOption.name)),
                                ]),
                                _c("b-icon", {
                                  attrs: {
                                    icon: active ? "angle-up" : "angle-down",
                                  },
                                }),
                              ],
                              1
                            )
                          },
                        },
                      ],
                      null,
                      false,
                      1153909097
                    ),
                    model: {
                      value: _vm.selectedOption,
                      callback: function ($$v) {
                        _vm.selectedOption = $$v
                      },
                      expression: "selectedOption",
                    },
                  },
                  _vm._l(_vm.options, function (option) {
                    return _c(
                      "b-dropdown-item",
                      {
                        key: option.id,
                        attrs: {
                          id: option.id,
                          value: option,
                          "aria-role": "listitem",
                        },
                        on: {
                          change: function ($event) {
                            return _vm.refresh()
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(option.name) + " ")]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _c("div", { staticClass: "column" }, [
              _c(
                "section",
                [
                  _c(
                    "b-field",
                    [
                      _c(
                        "b-upload",
                        {
                          attrs: {
                            id: "upload-bank-entries",
                            expanded: "",
                            disabled:
                              !_vm.checkUserFeature(
                                "element.cash-flows.bank-entries.button.upload"
                              ) ||
                              _vm.selectedOption.value === null ||
                              _vm.isProcessingFile,
                          },
                          on: { input: _vm.processFile },
                          model: {
                            value: _vm.uploadedFile,
                            callback: function ($$v) {
                              _vm.uploadedFile = $$v
                            },
                            expression: "uploadedFile",
                          },
                        },
                        [
                          _c(
                            "a",
                            { staticClass: "button is-primary is-fullwidth" },
                            [
                              !_vm.isProcessingFile
                                ? _c(
                                    "div",
                                    [
                                      _c("b-icon", {
                                        attrs: { icon: "upload" },
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.uploadedFile
                                              ? _vm.uploadedFile.name
                                              : _vm.uploadInstructions
                                          )
                                        ),
                                      ]),
                                    ],
                                    1
                                  )
                                : _c("span", [
                                    _c("i", {
                                      staticClass: "fas fa-spinner fa-spin",
                                    }),
                                    _c("span", { staticClass: "pl-3" }, [
                                      _vm._v(
                                        _vm._s(
                                          `Procesando archivo ${_vm.uploadedFile.name}`
                                        )
                                      ),
                                    ]),
                                  ]),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  !_vm.uploadedFile
                    ? _c("p", { staticClass: "is-size-7 has-text-grey" })
                    : !_vm.isFileExtensionValid
                    ? _c("p", { staticClass: "is-size-7 has-text-danger" }, [
                        _vm._v(" " + _vm._s(_vm.uploadInstructions) + " "),
                      ])
                    : _vm.fileContentErrorMessage !== null
                    ? _c(
                        "p",
                        {
                          staticClass: "is-size-7 has-text-danger",
                          attrs: { id: "error-message" },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.fileContentErrorMessage) + " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm.selectedOption.value === "BANK_DEPOSITS_CL_BCI"
                    ? _c("div", { staticClass: "is-size-7 has-text-grey" }, [
                        _c(
                          "a",
                          {
                            attrs: {
                              id: "download-deposits-template",
                              expanded: "",
                            },
                            on: { click: _vm.createDepositsWorkbook },
                          },
                          [
                            _c("b-icon", { attrs: { icon: "download" } }),
                            _vm._m(0),
                          ],
                          1
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
          _c("div", { staticClass: "control has-text-right" }, [
            _c(
              "button",
              {
                staticClass: "button is-button-primary",
                attrs: {
                  id: "create-bank-entries",
                  disabled: !_vm.isFileContentValid,
                },
                on: { click: _vm.createBankEntries },
              },
              [
                _vm.isCreating
                  ? _c("span", [
                      _c("i", { staticClass: "fas fa-spinner fa-spin" }),
                    ])
                  : _c("span", [_vm._v(_vm._s(_vm.$t("generalWords.Upload")))]),
              ]
            ),
          ]),
        ])
      : _c("section", [
          _c(
            "div",
            { staticClass: "control has-text-centered" },
            [
              _vm.errorMessageOnCreating !== null
                ? _c("Message", {
                    attrs: {
                      id: "error-message",
                      message: _vm.errorMessageOnCreating.message,
                      icon: _vm.errorMessageOnCreating.icon,
                      "as-card": false,
                    },
                  })
                : _c(
                    "div",
                    [
                      _c("p", { staticClass: "has-text-left is-size-6" }, [
                        _vm._v(
                          _vm._s(_vm.$t("treasury.bankEntriesUploadResults")) +
                            ":"
                        ),
                      ]),
                      _vm.bankEntriesResponse.errors.length > 0
                        ? _c(
                            "b-table",
                            {
                              attrs: {
                                hoverable: "",
                                data: _vm.bankEntriesResponse.errors,
                              },
                            },
                            [
                              _c("b-table-column", {
                                attrs: {
                                  field: "errors",
                                  label: _vm.$t("generalWords.Errors"),
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (bankEntryResponseError) {
                                        return [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "tag is-primary is-alert is-size-6",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  bankEntryResponseError.row
                                                    .message
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2425115538
                                ),
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "b-table",
                        {
                          attrs: {
                            hoverable: "",
                            data: _vm.bankEntriesResponseTable,
                          },
                        },
                        [
                          _c("b-table-column", {
                            attrs: {
                              field: "bankEntryId",
                              label: _vm.$t(
                                "treasury.bankTransactionNumberLabel"
                              ),
                              centered: true,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (bankEntryResponseTable) {
                                  return [
                                    bankEntryResponseTable.row.bankEntryId
                                      ? _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                bankEntryResponseTable.row
                                                  .bankEntryId
                                              ) +
                                              " "
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("b-table-column", {
                            attrs: {
                              field: "idNumber",
                              label: _vm.$t("treasury.originIdLabel"),
                              centered: true,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (bankEntryResponseTable) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          bankEntryResponseTable.row.idNumber
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("b-table-column", {
                            attrs: {
                              field: "date",
                              label: _vm.$t("generalWords.Date"),
                              centered: true,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (bankEntryResponseTable) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          bankEntryResponseTable.row.date
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("b-table-column", {
                            attrs: {
                              field: "accountingDate",
                              label: _vm.$t("treasury.accountableDateLabel"),
                              centered: true,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (bankEntryResponseTable) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          bankEntryResponseTable.row
                                            .accountingDate
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("b-table-column", {
                            attrs: {
                              field: "amount",
                              label: _vm.$t("generalWords.Amount"),
                              centered: true,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (bankEntryResponseTable) {
                                  return [
                                    bankEntryResponseTable.row.amount
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tag is-primary is-light is-size-6",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.formatNumberByCountry(
                                                    bankEntryResponseTable.row
                                                      .amount
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c("b-table-column", {
                            attrs: {
                              field: "status",
                              label: "Status",
                              centered: true,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (bankEntryResponseTable) {
                                  return [
                                    bankEntryResponseTable.row.status
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "tag is-primary is-light is-size-6",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  bankEntryResponseTable.row
                                                    .status
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
              _c(
                "button",
                {
                  staticClass: "button is-button-primary",
                  attrs: { id: "refresh-file-uploading" },
                  on: {
                    click: function ($event) {
                      return _vm.refresh(true)
                    },
                  },
                },
                [_c("span", [_vm._v("Ok")])]
              ),
            ],
            1
          ),
        ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("u", [
      _c("span", { staticClass: "pl-2" }, [
        _vm._v("Descargar template Depósitos"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }